/* eslint react/prop-types: 0 */
import React from 'react';
import { EMPTINESS_SIGN } from 'rp-react-table';
import { HorseLink } from '../../shared/links/ProfileLink';
import ResultLink from '../../shared/links/ResultLink';
import Abbr from '../../shared/Abbr';
import { yardsToFurlongs } from '../../utils/distance';
import { formatDate } from '../../utils/date';
import formatTime from '../../utils/formatTime';

const columns = (courseName, courseUid, raceType) => [
    {
        key: 'distanceYards',
        header: 'distance',
        /** for IRE courses use average-times request
         *  it has distanceYard and noOfObstacles instead of distanceYards and noOfFences
         */
        cell: ({ distanceYards, distanceYard, raceTypeCode, noOfFences, noOfObstacles }) => (
            <span>
                {yardsToFurlongs(distanceYards || distanceYard)}
                {raceType === 'jumps' && raceTypeCode ? `(${raceTypeCode})` : ''}
                {noOfFences || noOfObstacles ? `(${noOfFences || noOfObstacles})` : ''}
            </span>
        ),
    },
    {
        key: 'horseName',
        header: 'record holder',
        cell: ({ horseName, horseUid, horseCountryOriginCode, rpAgesAllowedDesc }) => (
            horseUid || horseName ? (
                <span>
                    <HorseLink horseUid={horseUid} horseStyleName={horseName} />
                    &nbsp;({horseCountryOriginCode})
                    &nbsp;({rpAgesAllowedDesc})
                </span>
            ) : EMPTINESS_SIGN
        ),
    },
    {
        key: 'raceDate',
        header: 'date',
        cell: ({ raceInstanceUid, raceDate }) => (
            <ResultLink
                courseName={courseName}
                courseUid={+courseUid}
                raceInstanceUid={raceInstanceUid}
                raceDatetime={raceDate}
            >
                {formatDate(raceDate, 'DDMMMYY')}
            </ResultLink>
        ),
    },
    {
        key: 'winnersTime',
        header: 'course record',
        cell: ({ raceInstanceUid, raceDate, winnersTime }) => (
            winnersTime ? (
                <Abbr
                    title={formatTime(winnersTime)}
                >
                    <ResultLink
                        courseName={courseName}
                        courseUid={+courseUid}
                        raceInstanceUid={raceInstanceUid}
                        raceDatetime={raceDate}
                        className="pp-abbr__inner"
                    >
                        {formatTime(winnersTime)}
                    </ResultLink>
                </Abbr>
            ) : EMPTINESS_SIGN
        ),
    },
    {
        key: 'averageTimeSec',
        header: 'rp standard',
        cell: ({ averageTimeSec }) => formatTime(averageTimeSec),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/course/courseRecords/columns.jsx